<div id="app-layout-default">
    <app-header  style="height: 48px;"></app-header>
    <app-sidenav>
        <div class="content" role="main" fxFlex>
            <router-outlet></router-outlet>
        </div>
    </app-sidenav>
</div>
